/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {merge} from 'rxjs/observable/merge';
import {ProfessionalLicenseService} from '../../../../../domain/model/licenses-certifications/professional/professional-license.service';
import {ScreensManager, ScreensManagerDeps} from '../../../../../components/sections/service/screen-manager.class';
import {NavigableNode} from '../../../../../components/sections/service/navigable-node.class';
import {Screen} from '../../../../../components/sections/service/screen.class';

interface Parameters {
    professionalLicenseIndex: string;
}

@Injectable()
export class PermitScreensManager extends ScreensManager {

    private _professionalLicenseIndexSubject$ = new BehaviorSubject<number>(undefined as any);

    get professionalLicenseIndex() { return this._professionalLicenseIndexSubject$.getValue(); }

    set professionalLicenseIndex(value: number) { this._professionalLicenseIndexSubject$.next(value); }

    private _requiredByProfessionalLicense?: boolean = false;

    constructor(smgm: ScreensManagerDeps,
                private readonly _professionalLicenseService: ProfessionalLicenseService,
                private readonly _router: Router) {
        super(smgm);
        this.screenChange$ = this._professionalLicenseIndexSubject$.distinctUntilChanged().map(() => true).publishReplay(1).refCount();
    }

    init(parent: NavigableNode<any, any>) {
        super.init(parent);
        merge(this._professionalLicenseService.changes$, this._professionalLicenseIndexSubject$.distinctUntilChanged())
            .switchMap(() => this.refresh()).subscribe(() => {});
    }

    setCurrentScreen(screen: Screen, route: ActivatedRouteSnapshot) {
        super.setCurrentScreen(screen, route);
        this.professionalLicenseIndex = +(route.params as Parameters).professionalLicenseIndex;
    }

    navigate(professionalLicenseIndex: number): Observable<boolean> {
        this.professionalLicenseIndex = professionalLicenseIndex;
        return this.refreshed$.filter(value => value).first()
            .flatMap(() => Observable.fromPromise(this._router.navigateByUrl(this._pathFromRootUsing({
                professionalLicenseIndex: this.professionalLicenseIndex
            }))));
    }

    hasPreviousScreen(): boolean { return false; }

    hasNextScreen(): boolean { return false; }

    navigateToPreviousScreen(): Observable<boolean> { return Observable.of(true); }

    navigateToNextScreen(): Observable<boolean> { return Observable.of(true); }

    navigateToFirstScreen(): Observable<boolean> { return this.navigate(this.professionalLicenseIndex); }

    navigateToLastScreen(): Observable<boolean> { return this.navigate(this.professionalLicenseIndex); }

    skip(): boolean { return !this._requiredByProfessionalLicense; }

    skipFor(professionalLicenseIndex: number): Observable<boolean> {
        this.professionalLicenseIndex = professionalLicenseIndex;
        return this.refreshed$.filter(value => value).first().map(() => this.skip());
    }

    protected _doRefresh(): Observable<boolean> {
        return this.professionalLicenseIndex
            ? this._professionalLicenseService.getCurrentUserModelEntry(this.professionalLicenseIndex)
                .map(license => this._requiredByProfessionalLicense = !!license && license.needsControlSubstancePermit)
            : Observable.of(true);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/professional/permit/permit-screens-manager.service.ts